module.exports = __webpack_public_path__ + "img/9e1fa90.svg";